import {
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
} from "@/components/ui/command";

import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { useState, useEffect } from "react";
import { Button } from "../button";
import { Check, ChevronDown } from "lucide-react";
import { cn } from "@/lib/utils";

interface ComboboxType {
  list?: {
    label: string;
    value: string;
  }[];
  defaultValue?: string | number;
  setFilter?: any;
  name?: string;
  label?: string;
  disabled?: boolean;
  className?: string;
  showLabel?: boolean;
  onSearch?: (value: string) => void;
}
export default function Combobox({
  list,
  setFilter,
  defaultValue,
  label,
  disabled,
  className,
  showLabel = true,
  onSearch,
}: ComboboxType) {
  const [open, setOpen] = useState(false);
  const [value, setValue] = useState(defaultValue ?? "");

  // Update local value when defaultValue changes
  useEffect(() => {
    setValue(defaultValue ?? "");
  }, [defaultValue]);

  return (
    <Popover open={open} onOpenChange={setOpen} modal={true}>
      <PopoverTrigger asChild>
        <div className="relative">
          {showLabel && <span className="absolute p-0 text-[11px] left-2 -top-1.5 px-1 bg-white capitalize">
            {label?.split('*').map((part, index, array) => (
              <span key={index}>
                {part}
                {index < array.length - 1 && <span className="text-red-500">*</span>}
              </span>
            ))}
          </span>}
          <Button
            variant="outline"
            role="combobox"
            aria-expanded={open}
            disabled={disabled}
            className={cn(` w-full text-left   border-[1px] hover:bg-transparent  justify-between font-normal capitalize`, className)}
          >
            <span className="text-ellipsis whitespace-nowrap overflow-hidden">
              {value
                ? list?.find((list) => list.label == value)?.label
                : "Select " + label?.toLowerCase()}
            </span>
            <ChevronDown className="ml-2 h-4 w-4 shrink-0 opacity-50" />
          </Button>
        </div>
      </PopoverTrigger>
      {!disabled && (
        <PopoverContent className="w-full max-w-[330px]  p-0 " side="bottom" align="end" >
          <Command>
            <CommandInput placeholder={`Search ${label}`}
            onValueChange={(val) => onSearch?.(val)} />
            <CommandEmpty>No list found.</CommandEmpty>
            <CommandList className="shadow-sm max-h-[200px] custom-scrollbar">
              <CommandGroup>
                {list &&
                  list?.map((item, i) => (
                    <CommandItem
                      className="capitalize text-left "
                      key={i}
                      value={item.label}
                      onSelect={(currentValue) => {

                        setValue(currentValue == value ? "" : currentValue);
                        setFilter(currentValue == value ? "" : currentValue);
                        setOpen(false);
                      }}
                    >
                      <Check
                        className={cn(
                          "mr-2 h-4 w-4",
                          value === item.label ? "opacity-100" : "opacity-0"
                        )}
                      />
                      {item.label}
                    </CommandItem>
                  ))}
              </CommandGroup>
            </CommandList>
          </Command>
        </PopoverContent>
      )}
    </Popover>
  );
}
